<template>
  <div>
    <div class="result">
      <p><span><strong>Resultat cerca per tot internet</strong></span></p>
      <p>
        <strong>Adreça:</strong> {{result.address}}
        <br>
        <strong>Coordenades:</strong> {{result.latlng.coordinates[1]}}, {{result.latlng.coordinates[0]}}
      </p>
    </div>
    <div class="tools" v-if="result">
      <q-btn flat dense
        icon="delete"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar'

export default {
  name: 'SearchResultPopup',
  props: ['feature'],
  components: {
    QBtn
  },
  computed: {
    result () {
      if (this.feature) {
        return this.feature
      } else {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.result {
  margin-top: 20px;
}
.tools {
  border-top: 1px dashed #ddd;
  margin-top: 10px;
  padding: 8px 0px 0px 0px;
}
.tool-remove-result {
  font-size: 0.8em;
  text-align: center;
  display: inline-block;
  background-color: #eee;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>
